export default "__VITE_ASSET__B$Fwimod__"